import {Grid} from "@mui/material";
import {Button, CountrySelect, Input} from "../../../library";
import {Controller, useForm} from "react-hook-form";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import React from "react";
import dayjs from "dayjs";
import AffiliateLinkSelect from "./AffiliateLinkSelect";
import CompanySelect from "./CompanySelect";

export const FilterUsers = ({loading, setLoading, filterCallback}) => {

  const {
    handleSubmit,
    register,
    control,
    reset
  } = useForm({
    mode: "onChange", defaultValues: {
      affiliate_link_offer: "",
      country: "",
      company: "",
      userid: '',
      from_date: "",
      to_date: ""
    },
  });

  const onSubmit = (formData) => {
    setLoading(true);
    const {
      affiliate_link_offer,
      country,
      company,
      userid,
      from_date,
      to_date,
    } = formData;
    const data = {
      user_id: userid,
      country,
      offer: affiliate_link_offer,
      company,
      date_start: from_date ? dayjs(from_date).format("YYYY-MM-DD") : undefined,
      date_end: to_date ? dayjs(to_date).format("YYYY-MM-DD") : undefined,
    }

    filterCallback(1, data)
  };

  const onReset = () => {
    reset();
    filterCallback(1);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid sx={{
        marginBottom: 4
      }} container columnSpacing={"1rem"} rowSpacing={"1rem"}>
        <Grid item xl={3} lg={6} xs={12}>
          <Input
            data={{
              label: "User ID:", type: "text", settings: {
                ...register("userid"),
              }, name: "userid",
            }}
          />
        </Grid>
        <Grid item xl={3} lg={6} xs={12}>
          <CountrySelect control={control} required={false}/>
        </Grid>
        <Grid item xl={3} lg={6} xs={12}>
          <AffiliateLinkSelect control={control} required={false}/>
        </Grid>
        <Grid item xl={3} lg={6} xs={12}>
          <CompanySelect control={control} required={false}/>
        </Grid>
        <Grid item xs={12} sx={{
          display: "flex", alignItems: "end"
        }}>
          <Grid item xl={2} lg={6} xs={12}>
            <Controller
              name="from_date"
              control={control}
              render={({field}) => (<LocalizationProvider
                dateAdapter={AdapterDayjs}
              >
                <DatePicker
                  showDaysOutsideCurrentMonth
                  fixedWeekNumber={6}
                  dayOfWeekFormatter={(day) => {
                    return day.slice(0, 2);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{
                    popper: {
                      className: "bo-calendar-popper",
                    }, mobilePaper: {
                      className: "bo-calendar-popper",
                    },
                  }}
                  className="bo-calendar"
                  disableFuture={true}
                  value={field.value}
                  defaultValue={field.value}
                  onChange={(newValue) => field.onChange(newValue)}
                />
              </LocalizationProvider>)}/>
          </Grid>
          <p className="bo-calendar-to">to</p>
          <Grid item xl={2} lg={6} xs={12}>
            <Controller
              name="to_date"
              control={control}
              render={({field}) => (<LocalizationProvider
                dateAdapter={AdapterDayjs}
              >
                <DatePicker
                  showDaysOutsideCurrentMonth
                  fixedWeekNumber={6}
                  dayOfWeekFormatter={(day) => {
                    return day.slice(0, 2);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{
                    popper: {
                      className: "bo-calendar-popper",
                    }, mobilePaper: {
                      className: "bo-calendar-popper",
                    },
                  }}
                  className="bo-calendar"
                  disableFuture={true}
                  value={field.value}
                  defaultValue={field.value}
                  onChange={(newValue) => field.onChange(newValue)}
                />
              </LocalizationProvider>)}/>
          </Grid>
        </Grid>
        <Grid item>
          <Button
            isLoading={loading}
            className="settings__btn"
            color="orange"
            size="middle"
            type="submit"
          >
            Search
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={loading}
            className="settings__btn"
            color="white"
            size="middle"
            type="button"
            onClick={onReset}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd"
                    d="M6.46967 6.46967C6.76256 6.17678 7.23744 6.17678 7.53033 6.46967L17.5303 16.4697C17.8232 16.7626 17.8232 17.2374 17.5303 17.5303C17.2374 17.8232 16.7626 17.8232 16.4697 17.5303L6.46967 7.53033C6.17678 7.23744 6.17678 6.76256 6.46967 6.46967Z"
                    fill="black"/>
              <path fillRule="evenodd" clipRule="evenodd"
                    d="M17.5303 6.46967C17.8232 6.76256 17.8232 7.23744 17.5303 7.53033L7.53033 17.5303C7.23744 17.8232 6.76256 17.8232 6.46967 17.5303C6.17678 17.2374 6.17678 16.7626 6.46967 16.4697L16.4697 6.46967C16.7626 6.17678 17.2374 6.17678 17.5303 6.46967Z"
                    fill="black"/>
            </svg>
            Reset
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}